import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import HeaderFooter from "@components/dumb/HeaderFooter";
import Account from "@components/smart/account";
import HowTo from "@components/smart/how-to";
import MainBanner from "@components/smart/main-banner";
import QNA from "@components/smart/qna";
import Rewards from "@components/smart/rewards";
import StaticHeaderBar from "@components/dumb/StaticHeaderBar";
import {useTranslation} from 'react-i18next'
import RootStore from "@stores"
import { Helmet } from "react-helmet";
import { MGMSeos } from "@interfaces/portal";
import { Lang } from "@interfaces/app";

interface ProtalProps {
    lang: Lang
}
const Portal: React.FC<ProtalProps> = observer((props) => {
    const {i18n} = useTranslation();
    const language = i18n.language;
    const [mgmSeos, setMgmSeos] = useState<MGMSeos>()
    const {
        getPortalCommonContent,
        getOrangeBarMgmCode,
        portalContent,
        orangeBarMgmCode,
    } = RootStore.PortalStore;
    const {
        mgmRefferCode
    } = RootStore.BasicInfoStore;
    const [showStaticBar, setShowStaticBar] = useState(true);
    const componentMap: Record<string, JSX.Element> = {
        "main-banner": <MainBanner />,
        "account": <Account />,
        "how-to": <HowTo />,
        "qna": <QNA />,
        "rewards-offer": <Rewards />,
    }


    useEffect(() => {
        const getOrangeBar = async () => {
            let [e, res] = await getOrangeBarMgmCode()
        }
        getOrangeBar()
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
        const getData = async () => {
            let [e, res] = await getPortalCommonContent()
            console.log(e, res);
        }
        getData();
    }, [getPortalCommonContent])

    useEffect(() => {
        let langMgmSeos = i18n.getResource(language, "portal", "mgmSeos")
        if (langMgmSeos) {
            console.log(langMgmSeos, 'mgmSeos');
            // updateSeoInfo(langMgmSeos[0])
            setMgmSeos(langMgmSeos[0])
        }
    }, [portalContent, language, i18n])

    


    // const updateSeoInfo = (mgmSeos: any) => {
    //     // 设置标题
    //     document.title = mgmSeos.title;

    //     // 设置或更新 meta description
    //     const descriptionMeta = document.querySelector('meta[name="description"]');
    //     if (descriptionMeta) {
    //         descriptionMeta.setAttribute("content", mgmSeos.description);
    //     } else {
    //         const newDescriptionMeta = document.createElement("meta");
    //         newDescriptionMeta.setAttribute("name", "description");
    //         newDescriptionMeta.setAttribute("content", mgmSeos.description);
    //         document.head.appendChild(newDescriptionMeta);
    //     }
    //     // 设置或更新 meta icon
    //     const favicon: HTMLLinkElement | null = document.querySelector("link[rel='icon']");
    //     if (favicon) {
    //         favicon.href = mgmSeos.iconList[0].iconUrl; // 设置新的图标路径
    //     } else {
    //         const newFavicon = document.createElement("link");
    //         newFavicon.rel = "icon";
    //         newFavicon.href = mgmSeos.iconList[0].iconUrl;
    //         document.head.appendChild(newFavicon);
    //     }

    //     // 动态创建或更新 <meta property="og:title">
    //     let ogTitle = document.querySelector('meta[property="og:title"]');

    //     if (!ogTitle) {
    //         ogTitle = document.createElement('meta');
    //         ogTitle.setAttribute('property', 'og:title');
    //         document.head.appendChild(ogTitle);
    //     }
    //     ogTitle.setAttribute('content', mgmSeos.title);

    //     // 动态创建或更新 <meta property="og:description">
    //     let ogDescription = document.querySelector('meta[property="og:description"]');
    //     if (!ogDescription) {
    //         ogDescription = document.createElement('meta');
    //         ogDescription.setAttribute('property', 'og:description');
    //         document.head.appendChild(ogDescription);
    //     }
    //     ogDescription.setAttribute('content', mgmSeos.description);

    //     // 动态创建或更新 <meta property="og:image">
    //     let ogImage = document.querySelector('meta[property="og:image"]');
    //     if (!ogImage) {
    //         ogImage = document.createElement('meta');
    //         ogImage.setAttribute('property', 'og:image');
    //         document.head.appendChild(ogImage);
    //     }
    //     ogImage.setAttribute('content', mgmSeos.image);
    // }

    return (
        <React.Fragment>
            {
                /**
                 * seo content 
                 */
                mgmSeos && 
                <Helmet>
                    <title>{mgmSeos.title}</title>
                    <meta name="description" content={mgmSeos.description} />
                    <link rel="icon" href={mgmSeos.iconList && mgmSeos.iconList[0].iconUrl} />
                    <meta property="og:title" content={mgmSeos.title} />
                    <meta property="og:description" content={mgmSeos.description} />
                    <meta property="og:image" content={mgmSeos.image} />
                    <meta name="keywords" content="频频友赏, 香港宽频" />
                </Helmet>
            }
            {showStaticBar && orangeBarMgmCode &&  <StaticHeaderBar mgmCode={orangeBarMgmCode} close={() => setShowStaticBar(false)} />}
            <HeaderFooter lang={props.lang}>
                {
                    Object.keys(portalContent).length > 0 &&
                    portalContent.mgmOrderings?.map((item, index) => {
                        return <div key={index}>{componentMap[item.orderSection]}</div>
                    })
                }
            </HeaderFooter>
        </React.Fragment>
    )
})

export default Portal;